export enum ErrorTypeEnum {
    NoError = 0,
    Info = 1,
    Warning = 2,
    Error = 3,
    Success = 4,
    Custom = 5
}

export enum SortOrder {
    NotDefined = 0,
    Asc = 1,
    Desc = -1
}

export enum KeyDownCodes {
    BackSpace = 8,
    Tab = 9,
    Enter = 13,
    Escape = 27,
    Space = 32,
    PageUp = 33,
    PageDown = 34,
    End = 35,
    Home = 36,
    ArrowLeft = 37,
    ArrowUp = 38,
    ArrorRight = 39,
    ArrowDown = 40,
    Insert = 45,
    Delete = 46,
    Plus = 170,
    Minus = 109
}

export enum TextAlignment {
    Left = 'text-left',
    Center = 'text-center',
    Right = 'text-right'
}

export enum ProductIndividualSearchFilter
{
    ChassisNumberOrPINumber = "Chassis/Product Individual Number",    
    SerialNumber = "Serial Number",
    KNRNumber="KNR Number",
    ArchivedProduct = "Archived Product"
}

export const ACCEPTED_EXCEL_FILE_TYPES = [
    '.xls', '.xlsx', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', '.csv'
]

// Equivalent of DateTime.ParseExact(value, "yyyy-MM-dd", CultureInfo.InvariantCulture) plus the formats Excel commonly emits.
export const EXCEL_DATE_PARSE_FORMATS = [
    'YYYY-MM-DD',
    'YYYY-MM-DDTHH:mm:ss',
    'YYYY-MM-DD HH:mm:ss',
    'MM/DD/YYYY',
    'M/D/YYYY',
    'MM/DD/YY',
    'M/D/YY',
    'DD-MM-YYYY',
    'DD.MM.YYYY',
    'YYYY/MM/DD',
    'DD/MM/YYYY',
    'D/M/YYYY',
    'DD-MM-YYYY',
    'D-M-YYYY',
    'DD.MM.YYYY',
    'D.M.YYYY',
    'YYYYMMDD'
];
export const TARGET_DATE_FORMAT = 'YYYY-MM-DD';
// moment's 'en' locale is the equivalent of .NET CultureInfo.InvariantCulture.
export const INVARIANT_CULTURE = 'en';
